import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class CountryService {
  private countryCodeSubject = new BehaviorSubject<string>(localStorage.getItem('countryCode') || '');
  countryCode$ = this.countryCodeSubject.asObservable();

  setCountryCode(code: string) {
    localStorage.setItem('countryCode', code);
    this.countryCodeSubject.next(code);
  }
}